import {
  HttpErrorResponse,
  HttpHandler,
  HttpHeaderResponse,
  HttpInterceptor,
  HttpProgressEvent,
  HttpRequest,
  HttpResponse,
  HttpSentEvent,
  HttpUserEvent
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { throwError } from 'rxjs/internal/observable/throwError';
import { catchError } from 'rxjs/operators';

@Injectable()
export class JwtWInterceptor implements HttpInterceptor {
  constructor(private _router: Router) {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<
    | HttpSentEvent
    | HttpHeaderResponse
    | HttpProgressEvent
    | HttpResponse<any>
    | HttpUserEvent<any>
    | any
  > {
    let u = localStorage.getItem('Usuario');
    let p = localStorage.getItem('Ponto');

    let currentUser;
    //console.log(u);
    //console.log(p);
    if (u !== null) {
      currentUser = JSON.parse(u);
      //console.log(currentUser);
    } else if (p !== null) {
      //console.log(currentUser);
      currentUser = JSON.parse(p);
    } else {
      //console.log(currentUser);
      return next.handle(request);
    }
    //console.log(currentUser);
    if (currentUser && currentUser.token && !request.url.includes('/v1/integra/meuspontos/pontos/comprovante')) {
      request = request.clone({
        setHeaders: {
          Authorization: `Bearer ${currentUser.token}`,

        },
      });
      //console.log('Colocou auth');
      //console.log(request.body);
    }
    //console.log(currentUser);
    return next.handle(request).pipe(
      catchError((error) => {


        if (error instanceof HttpErrorResponse) {
        //  console.log('HttpErrorResponse',error);
          if (
            (<HttpErrorResponse>error).status === 401 ||
            (<HttpErrorResponse>error).status === 403 ||
            (<HttpErrorResponse>error).status === 400
          ) {
            return this.handleError(error);
          }
          return this.handleError(error);
        }
        return throwError(() => new Error(error.message));
      })
    );
  }

  private handleError(err: HttpErrorResponse): Observable<HttpErrorResponse> {
    //console.log(err);
    if (err.status === 401 || err.status === 403) {
      localStorage.removeItem('Usuario');
      localStorage.removeItem('Ponto');
      this._router.navigate(['login'], { skipLocationChange: false });
     // return throwError(() => new Error(err.message));
    }
    // handle your auth error or rethrow

    return throwError(() => new Error(err.error || err.message));
    //return throwError(() => new Error(err.message));
  }
}
